import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { propPanelMixin } from "../../../../../lib/helpers";
import { DataStub } from '@tencent/data-schema-core';
import { DataForm } from '@tencent/data-schema/lib/vue-ui/DataForm';
import { getPropPanelContextOptions } from "../../../../../lib/comps/PropPanel/PropPanel/extraCtx";
import { cloneDeep, isEqual, omit } from "lodash-es";
import { ParamItem } from './ParamItem';
import { ParamContextProvide } from "../../../../../lib/comps/PropPanel/PropPanel/ParamItem/const";
let ParamContext = class ParamContext extends Vue {
  constructor() {
    super(...arguments);
    this.dataTemp = null;
    this.visibleFieldIds = [];
    this.dataForm = null;
  }
  get stub() {
    var _this$dataForm;
    return ((_this$dataForm = this.dataForm) === null || _this$dataForm === void 0 ? void 0 : _this$dataForm.rootStub) || new DataStub({
      schema: this.schema
    });
  }
  get dataSchemaContextOptions() {
    if (this.contextOptions) {
      return this.contextOptions;
    }
    return getPropPanelContextOptions(this);
  }
  created() {
    this.$watch(() => [this.data], ([data]) => {
      if (this.keepRef) {
        this.dataTemp = data;
        return;
      }
      // TODO: 用schema筛选需要的key 减少拷贝量
      const pathBlackList = ['children', 'slots', 'scopedSlots'];
      const newComp = omit(data, pathBlackList);
      if (!isEqual(newComp, this.dataTemp)) {
        this.dataTemp = cloneDeep(newComp);
      }
    }, {
      deep: true,
      immediate: true
    });
  }
  handleFormChangeEvent(n, o, changeTrace) {
    this.$emit('change', n, o, changeTrace);
  }
  handleDataFromCreated() {
    [this.dataForm] = this.$children;
  }
  updateVisibleFieldIds() {
    let ans = [];
    try {
      const r = this.stub.getFields();
      ans = [...r.fields.map(x => x.id), ...r.candidates.map(x => x.id)].filter(Boolean);
    } catch (_unused) {
      var _this$schema;
      ans = ((_this$schema = this.schema) === null || _this$schema === void 0 || (_this$schema = _this$schema.fields) === null || _this$schema === void 0 ? void 0 : _this$schema.map(x => x.id)) || [];
    }
    if (!isEqual(ans, this.visibleFieldIds)) {
      this.visibleFieldIds = ans;
    }
  }
  get renderParamItems() {
    var _this$schema2;
    const h = this.$createElement;
    if ((_this$schema2 = this.schema) !== null && _this$schema2 !== void 0 && (_this$schema2 = _this$schema2.ui) !== null && _this$schema2 !== void 0 && _this$schema2.type) return undefined;
    return this.schema.fields.filter(field => !field.hidden).filter(field => this.visibleFieldIds.includes(field.id)).map(field => h(ParamItem, {
      "key": field.id,
      "attrs": {
        "path": field.id
      }
    }));
  }
  /**  */
  render() {
    const h = arguments[0];
    const slot = this.$slots.default;
    // @ts-ignore
    return this.schema ? h(DataForm, _mergeJSXProps([{
      "class": "uc-dataForm-vertical",
      "ref": "dataForm",
      "attrs": {
        "schema": this.schema,
        "context-options": this.dataSchemaContextOptions
      },
      "on": {
        "change": (n, o, changeTrace) => {
          this.handleFormChangeEvent(n, o, changeTrace);
          this.updateVisibleFieldIds();
        }
      }
    }, {
      "on": {
        'hook:created': this.handleDataFromCreated,
        'hook:mounted': this.updateVisibleFieldIds
      }
    }, {
      "model": {
        value: this.dataTemp,
        callback: $$v => {
          this.dataTemp = $$v;
        }
      }
    }]), [slot || this.renderParamItems]) : null;
  }
};
__decorate([Model()], ParamContext.prototype, "data", void 0);
__decorate([Prop()], ParamContext.prototype, "schema", void 0);
__decorate([Prop()], ParamContext.prototype, "contextOptions", void 0);
__decorate([Prop()], ParamContext.prototype, "keepRef", void 0);
__decorate([Prop({
  default: ''
})], ParamContext.prototype, "resetMode", void 0);
__decorate([Prop()], ParamContext.prototype, "inputModes", void 0);
ParamContext = __decorate([Component({
  name: 'ParamContext',
  mixins: [propPanelMixin],
  provide() {
    return {
      [ParamContextProvide.context]: this
    };
  }
})], ParamContext);
export { ParamContext };
//# sourceMappingURL=ParamContext.js.map
